import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();
import AOS from "aos";
window.AOS = AOS;

import "@fortawesome/fontawesome-free/css/all";
import "controllers";
import 'bootstrap';
import "../js/landing_main.js";
import "./landing.scss";
